<div class="webinar-promo">
  <a
    class="webinar-promo__poster"
    [href]="link"
    target="_blank"
    rel="noopener noreferrer"
    (click)="register(); $event.preventDefault()"
    >
    <span class="webinar-promo__artwork">
      <img
        src="/assets/webinar-mcp-date-free.webp"
        loading="lazy"
        alt="Live webinar: Flow Studio MCP Server — A closer look at the possibilities, with Audrie Gordon, AI Champion at Learning Compass.AI."
        />
      <span class="webinar-promo__date">{{ this.dateLabel }}</span>
    </span>
  </a>

  <div class="webinar-promo__actions">
    <button type="button" class="webinar-promo__btn webinar-promo__btn--primary" (click)="register()">
      Register Now &rarr;
    </button>
    <button type="button" class="webinar-promo__btn" (click)="close()">
      Maybe later
    </button>
  </div>
</div>
